import { NewButton } from 'components/NewButton';
import React, { ReactNode } from 'react';
import { IoClose } from 'react-icons/io5';
import {
  DrawerOverlay,
  DrawerContainer,
  DrawerHeader,
  CloseButton,
  DrawerContent,
  DrawerFooter
} from './styles';

export interface DrawerProps {
  /** Se o drawer está aberto ou fechado */
  open: boolean;
  /** Função para fechar o drawer */
  onClose: () => void;
  /** Título do drawer */
  title?: string;
  /** Conteúdo do drawer */
  children: ReactNode;
  /** Se deve mostrar os botões de ação no footer */
  showFooter?: boolean;
  /** Texto do botão de limpar/cancelar */
  clearButtonText?: string;
  /** Texto do botão de aplicar/confirmar */
  applyButtonText?: string;
  /** Função chamada ao clicar no botão de limpar */
  onClear?: () => void;
  /** Função chamada ao clicar no botão de aplicar */
  onApply?: () => void;
  /** Se os botões estão desabilitados */
  buttonsDisabled?: boolean;
  /** Largura customizada do drawer */
  width?: string;
  /** Se permite fechar clicando no overlay */
  closeOnOverlayClick?: boolean;
}

export const Drawer = ({
  open,
  onClose,
  title,
  children,
  showFooter = true,
  clearButtonText = "Limpar",
  applyButtonText = "Aplicar",
  onClear,
  onApply,
  buttonsDisabled = false,
  width,
  closeOnOverlayClick = true,
}: DrawerProps) => {
  const handleOverlayClick = () => {
    if (closeOnOverlayClick) {
      onClose();
    }
  };

  const handleClearClick = () => {
    if (onClear) {
      onClear();
    }
  };

  const handleApplyClick = () => {
    if (onApply) {
      onApply();
    }
    onClose();
  };

  return (
    <>
      <DrawerOverlay open={open} onClick={handleOverlayClick} />
      <DrawerContainer open={open} width={width}>
        <DrawerHeader>
          {title && <h2>{title}</h2>}
          <CloseButton onClick={onClose} aria-label="Fechar drawer">
            <IoClose />
          </CloseButton>
        </DrawerHeader>

        <DrawerContent hasHeader={true} hasFooter={showFooter}>
          {children}
        </DrawerContent>

        {showFooter && (
          <DrawerFooter>
            <NewButton
              variantType="outlined"
              onClick={handleClearClick}
              disabled={buttonsDisabled}
              sx={{
                width: ['calc(50% - 6px)', 220],
                display: 'flex',
                alignItems: 'center',
                marginTop: ['20px', '0'],
                gap: '12px',
                height: '40px',
                fontWeight: '600',
                whiteSpace: 'nowrap'
              }}
            >
              {clearButtonText}
            </NewButton>
            <NewButton
              variantType="filled"
              onClick={handleApplyClick}
              disabled={buttonsDisabled}
              sx={{
                width: ['calc(50% - 6px)', 220],
                display: 'flex',
                alignItems: 'center',
                marginTop: ['20px', '0'],
                gap: '12px',
                height: '40px',
                fontWeight: '600',
                whiteSpace: 'nowrap',
              }}
            >
              {applyButtonText}
            </NewButton>
          </DrawerFooter>
        )}
      </DrawerContainer>
    </>
  );
};
